import { Component } from '@angular/core';
import { FieldTypeConfig } from '@ngx-formly/core';
import { FieldType } from '@ngx-formly/material';



@Component({
  selector: 'app-formly-datepicker-field',
  template: `
    <input matInput
          type="text"
          [formControl]="formControl"
          [matDatepicker]="picker"
          [matDatepickerFilter]="to.datepickerOptions?.filter"
          [min]="to.minDate"
          [max]="to.maxDate"
          [formlyAttributes]="field"
          #dateInput>
    <ng-template #matSuffix>
      <mat-datepicker-toggle [for]="picker"  [matTooltip]="to.dateHelpText"></mat-datepicker-toggle>
    </ng-template>
    <mat-datepicker #picker></mat-datepicker>
  `
})
export class FormlyDatepickerTypeComponent extends FieldType<FieldTypeConfig> {

}
